import {ShortCargo} from "~/apps/packages/cargos/queries";
import {Cargo} from "~/apps/packages/warehouse-closure/queries";


export function getStatusColor(status: ShortCargo["status"]) {
    const mapping: {[key in ShortCargo["status"]]: string} = {
        "В порту": "#009ACF",
        "Ожидается": "#DA7C0F",
        "Убыл": "#6E798C",
        "Расформирован": "#6E798C",
    }
    return mapping[status];
}

export function humanizeCargoTag(tag: keyof Cargo["tags"]): string {
    switch (tag) {
        case "agentRelease":
            return "Откреплен"
        case "customsControl":
            return "Таможенный";
        case "terminalRelease":
            return "Склад закрыт";
        default:
            return tag;
    }
}